import { Upload } from 'hljd'
import { observable, action } from 'mobx'
class Store {
  @observable video = ''
  @observable showClip = false
  @observable videoInfo = null
  @observable coverPath = ''
  @observable choose_list = []
  @observable duration = 0
  @observable width = 0
  @observable height = 0
  @observable valueContent = []
  @observable isFail = false
  @observable failMsgg = ''
  @action
  // 初始化值回填方法，有些无用参数是否可以优化掉
  initValue = props => {
    const { value } = props
    this.valueContent = value?.[0]
    this.duration = value?.[0]?.content.duration
    this.video = value?.[0]?.content.mediaPath
    this.coverPath = value?.[0]?.content.coverPath
    this.width = value?.[0]?.content.width
    this.height = value?.[0]?.content.height
  }
  // 初始化onChange方法
  initChange = props => {
    const { onChange } = props
    this.onChange = onChange
  }
  // 上传前校验文件时长
  beforeUpload = async file => {
    if (!file.status) {
      if (file.type.indexOf('video') === -1) {
        this.isFail = true
        this.failMsgg = '仅支持rmvb、avi 和 mp4 等格式'
        return Promise.reject(file)
      }
      if (file.size > 1024 * 1024 * 500) {
        this.isFail = true
        this.failMsgg = '视频大小不能超过500M'
        return Promise.reject(file)
      }
      if (file.type.indexOf('mp4') > -1) {
        // mp4格式可以校验文件时长
        const duration = await Upload.checkDurationSync(file)
        if (duration > 300) {
          this.isFail = true
          this.failMsgg = '视频时长不能超过五分钟'
          return Promise.reject(file)
        }
      }
    }
  }
  // 拼接回调参数
  onChangeFormData = () => {
    const result = [
      {
        kind: 2,
        content: {
          coverPath: this.coverPath,
          height: this.height,
          mediaPath: this.video.split('?')[0],
          width: this.width,
          duration: this.duration
        }
      }
    ]
    this.onChange(result)
  }
  // 视频上传成功回调方法
  onVideoChange = val => {
    if (val.status === 'done') {
      this.isFail = false
      const { response, url } = val
      const { avinfo, duration } = response
      const { video: data } = avinfo
      const { width, height } = data
      this.videoInfo = val
      this.width = width
      this.height = height
      this.video = url
      this.duration = duration
      this.coverPath = this.getVideoFrames(val, [0])[0] // 截取视频第一帧作为封面图
      this.onChangeFormData()
    }
  }
  // 删除视频,清空视频相关值
  onVideoDelete = () => {
    this.video = ''
    const result = []
    this.onChange(result)
  }
  // maybe可以优化组件
  @observable showUpload = true
  // 这个两个方法统一掉
  onCoverChange = val => {
    if (val.url) {
      this.coverPath = val.url
      this.onChangeFormData()
      this.showUpload = !this.showUpload
    }
  }
  // 处理无法播放视频，考虑用Video组件替换
  handleVideoLoadError = e => {
    e.persist()
    this.video = this.video + '?avthumb/mp4/vcodec/libx264'
  }
  // 弹窗开启
  onClipShow = () => {
    console.log(this.video)
    if (!this.duration) {
      let vid = document.getElementById('show-video')
      this.duration = vid.duration
    }
    this.choose_list = this.getVideoFrames(
      this.videoInfo || this.valueContent.content,
      [
        0,
        (this.duration * 0.1).toFixed(2),
        (this.duration * 0.2).toFixed(2),
        (this.duration * 0.3).toFixed(2),
        (this.duration * 0.4).toFixed(2),
        (this.duration * 0.5).toFixed(2),
        (this.duration * 0.6).toFixed(2),
        (this.duration * 0.7).toFixed(2),
        (this.duration * 0.8).toFixed(2),
        (this.duration * 0.9).toFixed(2)
      ],
      1
    )
    this.showClip = true
  }
  // 弹窗关闭
  onClipCancle = () => {
    this.showClip = false
    this.draggable = false
  }
  @observable draggable = false
  @observable barleft = 0
  @observable barleftPadding = 0
  barMouseDown = e => {
    e.persist() //用于控制台输入，可去除
    if (e.target.id === 'bar') {
      this.draggable = true
      this.clientX = e.clientX // 记录初始位置
    }
  }
  barMouseMove = e => {
    if (this.draggable) {
      e.persist() //用于控制台输入，可去除
      const video = document.getElementById('video')
      this.barleft = this.barleftPadding + e.clientX - this.clientX
      if (this.barleft > 432) {
        this.barleft = 432
        e.clientX = 432
      }
      if (this.barleft < 0) {
        this.barleft = 0
        e.clientX = 0
      }
      video.currentTime = ((this.duration * this.barleft) / 432).toFixed(2)
    }
  }
  barMouseUp = e => {
    e.persist() //用于控制台输入，可去除
    // if (e.target.id === 'bar') {
    this.clientX = e.clientX // 更新浮标位置
    this.barleftPadding = this.barleft
    this.draggable = false
    // }
  }
  barMouseClick = e => {
    e.persist()
    if (e.target.id !== 'bar') {
      this.barleft = e.nativeEvent.layerX
      this.barleftPadding = e.nativeEvent.layerX
      const video = document.getElementById('video')
      video.currentTime = ((this.duration * this.barleft) / 432).toFixed(2)
    }
  }
  onClipOk = () => {
    this.coverPath = this.getVideoFrames(
      this.videoInfo || this.valueContent.content,
      [((this.duration * this.barleft) / 432).toFixed(2)]
    )[0] // 截取视频第一帧作为封面图
    this.draggable = false
    this.showClip = false
    this.onChangeFormData()
  }
  getVideoFrames = (video, frameOffsets, type) => {
    // type 用于标记是初始还会预览，初始0不携带宽高参数，预览1默认给定200宽度
    if (!frameOffsets || !video || frameOffsets.length < 1) {
      return []
    }
    return frameOffsets.map(
      offset =>
        `${video.url || video.mediaPath}?vframe/jpg/offset/${offset}${
          type ? `/w/200` : ''
        }`
    )
  }
}
export default Store
